/**
 * Avatar initials (S6 L3 review). A word's first character is taken whole, by code point: `word[0]` or `charAt(0)`
 * cut an emoji (or any astral symbol) to a lone surrogate, which draws as a broken glyph.
 */
export const firstLetter = (word: string): string => Array.from(word)[0] ?? '';

const wordsOf = (name: string): string[] => name.trim().split(/\s+/).filter((word) => word !== '');

/** The last two words' first letters: "Trần Văn Minh" → "VM". */
export const lastTwoInitials = (name: string): string =>
  wordsOf(name).slice(-2).map(firstLetter).join('').toUpperCase();

/** The first and the last word's first letters: "Bùi Văn Tâm" → "BT"; one word gives its own letter. */
export function firstLastInitials(name: string): string {
  const words = wordsOf(name);
  const picked = words.length > 1 ? [words[0]!, words[words.length - 1]!] : words;
  return picked.map(firstLetter).join('').toUpperCase();
}
